export class EnablePowerDmsApiModel {
  public PowerDmsEnabled: boolean;

  constructor(isActive: boolean) {
    this.PowerDmsEnabled = isActive;
  }
}
